<script setup>
import { ref } from 'vue'
import {createToaster} from "@meforma/vue-toaster";

const toaster = createToaster({
  position: "top-right",
  duration: 2000,
});
const props = defineProps({
  isOpen: Boolean,
  type: {
    type: String,
    default: ''
  },
  selectedIds: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits({
  close: null,
  confirm: (type) => {
    if (type) return true;
    console.warn('Cảnh báo: Confirm được gọi nhưng không có type!');
    return true;
  }
})

const loading = ref(false)

const closeForm = () => {
  emit('close')
}

const handleSubmit = async () => {
  emit('confirm', props.type)
};
</script>

<template>
  <div v-if="isOpen" class="form-sidebar-overlay" @click.self="!loading && closeForm()">
    <div class="form-sidebar">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h5 class="mb-0">Confirm</h5>
        <button class="btn-close" :disabled="loading" @click="closeForm"></button>
      </div>

      <div class="alert alert-info py-2" v-if="selectedIds.length > 0">
        <small>Danh sách ID: {{ selectedIds.join(', ') }}</small>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <span>Do you want to {{type}} this order?</span>
        </div>

        <div class="sidebar-footer d-flex gap-2 mt-auto">
          <button
            type="button"
            class="btn btn-outline-secondary w-100"
            :disabled="loading"
            @click="closeForm"
          >
            Hủy
          </button>
          <button
            type="submit"
            class="btn btn-primary w-100"
            :disabled="loading"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
            Xác nhận
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.form-sidebar-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 9999;
}

.form-sidebar {
  position: fixed;
  top: 0; right: 0;
  width: 400px; height: 100%;
  background: white;
  padding: 25px;
  box-shadow: -5px 0 15px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

.sidebar-footer {
  margin-top: auto; /* Đẩy cụm nút bấm xuống đáy sidebar */
  padding-top: 20px;
}

@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

/* Hiệu ứng loading cho nút */
.btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
</style>